<template>
  <g-page-wrapper>
    <template slot="pageTitle">
      <g-page-title :title="$t('pages_dashboard.title')"></g-page-title>
    </template>
    <g-contents>
      <div class="-container-resizing">
        <div class="-p-5">
          <div class="dashboard-layout">
            <select-top />
          </div>
          <div class="dashboard-layout -mt-5">
            <total-cost-prev-month />
            <contact-cost-last-month />
            <product-cost-list-prev-month />
          </div>
          <div class="dashboard-layout -mt-5">
            <usage-cost-and-payment-status />
            <prodcuct-use-cost />
          </div>
          <div class="dashboard-layout -mt-5">
            <service-request-status />
            <board-list-2 />
          </div>
        </div>
      </div>
    </g-contents>
  </g-page-wrapper>
</template>

<script>
import {AUTH_GROUP} from '@/constants/constants';
import SelectTop from './components/SelectTop'
import ContactCostLastMonth from './components/ContactCostLastMonth'
import ProductCostListPrevMonth from './components/ProductCostListPrevMonth'
import TotalCostPrevMonth from './components/TotalCostPrevMonth'
import ProdcuctUseCost from './components/ProdcuctUseCost'
import UsageCostAndPaymentStatus from './components/UsageCostAndPaymentStatus'
import ServiceRequestStatus from './components/ServiceRequestStatus'
import BoardList2 from './components/BoardList2'
import ServiceIntroCard from '@/pages/home/components/ServiceIntroCard'
import ServiceCard from '@/pages/home/components/ServiceCard'
import {mapGetters} from "vuex";

export default {
  name: 'home',
  components: {
    SelectTop,
    ContactCostLastMonth,
    ProductCostListPrevMonth,
    TotalCostPrevMonth,
    ProdcuctUseCost,
    UsageCostAndPaymentStatus,
    ServiceRequestStatus,
    BoardList2,
    ServiceIntroCard,
    ServiceCard
  },
  data () {
    return {
      selectSaler : {},
      param : {},
      customerDepts: [],
      AUTH_GROUP : AUTH_GROUP,
      finOpsInfo: {
        logoUrl: '/assets/images/ops/FinOps.png',
        name: this.$t('pages_dashboard_opsnow_service.title_1'),
        href: 'https://opsnow.com',
        supportUrl: 'https://support.bespinglobal.com/support/home',
        summary: '클라우드 비용 절감을 위한 자동화 기능을 제공합니다.',
        features: [
          '클라우드 비용 최적화 기능 제공',
          '조직 별 클라우드 비용 배분 기능 제공',
          'AI기반 이상비용 탐지 기능 제공'
        ]
      },
      helpNowInfo: {
        logoUrl: '/assets/images/ops/helpnow.png',
        name: this.$t('pages_dashboard_opsnow_service.title_2'),
        href: 'https://www.opsnow.com/service/chatbot',
        supportUrl: 'https://support.bespinglobal.com/support/home',
        summary: '지능형 챗봇 · 보이스봇 구축 및 운영을 위한 통합 관리 플랫폼입니다.',
        features: [
          '편리한 시나리오 빌더 및 멀티 채널 연동',
          '다양한 채널로 쌓이는 비정형 데이터 분석',
          '대화 품질 평가 및 자동 학습'
        ]
      },
      alertNoeInfo: {
        logoUrl: '/assets/images/ops/alertnow.png',
        name: this.$t('pages_dashboard_opsnow_service.title_3'),
        href: 'https://service.alertnow.ai',
        supportUrl: 'https://support.bespinglobal.com/support/home',
        summary: '3rd party tool에서 발생하는 알림을 통합 관리 해주는, 이벤트 통합 인지 플랫폼 입니다.',
        features: [
          '알림 통합 및 중복알림 제거',
          '빠르게, 정확한 담당자에게 알림 전송',
          '알림 발생 추이 리포트 제공'
        ]
      }
    }
  },
  computed : {
    ...mapGetters('user', ['userInfo']),
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue